import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
  // mode:'history',
  routes: [
    //首页路由配置
    { path: "", redirect: "/register" },  //路由重定向
    //分享注册页
    { path: "/register",name: "regesiter",component: resolve => require(["@/pages/share/index"], resolve),   //路由懒加载
      meta: {
        title: '分享注册'  //配置title 标题
      }
    },
    //八字找贵人
    // { path: "/guiren",name: "guiren",component: resolve => require(["@/pages/findGuiRen/guiren"], resolve),   //路由懒加载
    //   meta: {
    //     title: '八字找贵人'  //配置title 标题
    //   }
    // },
    // //逆天改运
    // { path: "/gaiyun",name: "gaiyun",component: resolve => require(["@/pages/gaiyin/gaiyun"], resolve),   //路由懒加载
    //   meta: {
    //     title: '逆天改运'  //配置title 标题
    //   }
    // },
    //信息验证
    { path: "/checkinfo",name: "checkinfo",component: resolve => require(["@/pages/gaiyunrule/checkinfo"], resolve),   //路由懒加载
      meta: {
        title: '信息验证'  //配置title 标题
      }
    },
    // //恋爱铃
    // { path: "/love",name: "love",component: resolve => require(["@/pages/lianailing/love"], resolve),   //路由懒加载
    //   meta: {
    //     title: '恋爱铃'  //配置title 标题
    //   }
    // },
    //动态分享
    { path: "/dynamic",name: "dynamic",component: resolve => require(["@/pages/dynamic/dynamic"], resolve),   //路由懒加载
      meta: {
        title: 'Fate'  //配置title 标题
      }
    },
    //系统消息
    { path: "/system",name: "system",component: resolve => require(["@/pages/systemsg/systemMsg"], resolve),   //路由懒加载
      meta: {
        title: '系统消息'  //配置title 标题
      }
    },
    //h5支付
    // { path: "/pay",name: "pay",component: resolve => require(["@/pages/h5pay/pay"], resolve),   //路由懒加载
    //   meta: {
    //     title: '支付'  //配置title 标题
    //   }
    // },
    //h5支付
    // { path: "/payStatus",name: "payStatus",component: resolve => require(["@/pages/h5pay/payStatus"], resolve),   //路由懒加载
    //   meta: {
    //     title: '支付完成'  //配置title 标题
    //   }
    // },
    //android用户充值协议
    { path: "/rulean",name: "rulean",component: resolve => require(["@/pages/androidRules/rules"], resolve),   //路由懒加载
      meta: {
        title: '充值协议'  //配置title 标题
      }
    },
    //ios用户充值协议
    { path: "/ruleios",name: "ruleios",component: resolve => require(["@/pages/iosRules/rules"], resolve),   //路由懒加载
      meta: {
        title: '充值协议'  //配置title 标题
      }
    },
    //隐私政策
    { path: "/privacy",name: "privacy",component: resolve => require(["@/pages/privacy/"], resolve),   //路由懒加载
      meta: {
        title: '隐私政策'  //配置title 标题
      }
    },
    //隐私政策
    { path: "/agreement",name: "agreement",component: resolve => require(["@/pages/agreement/"], resolve),   //路由懒加载
      meta: {
        title: '用户协议'  //配置title 标题
      }
    },
    //国际码 英文版
    { path: "/national", name: "national", component: resolve => require(["@/pages/national/"], resolve), },

  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js